// Odbicie lustrzane zapamiętujemy osobno dla każdego rodzaju materiału (tabliczki zwykle są
// drukowane w lustrze do sublimacji, nekrologi nie). Wspólne dla panelu generowania i obu edytorów,
// żeby wybór nie „gubił się” po przejściu do edycji. Bez localStorage działa domyślnie „wyłączone”.

const MIRROR_STORAGE_KEY = 'nekrodruk:mirrorByLayout';

export const readMirrorSetting = (layoutType) => {
    try {
        const stored = JSON.parse(localStorage.getItem(MIRROR_STORAGE_KEY) || '{}');
        return stored[layoutType] === true;
    } catch {
        return false;
    }
};

export const saveMirrorSetting = (layoutType, value) => {
    try {
        const stored = JSON.parse(localStorage.getItem(MIRROR_STORAGE_KEY) || '{}');
        localStorage.setItem(MIRROR_STORAGE_KEY, JSON.stringify({ ...stored, [layoutType]: value }));
    } catch {
        // brak dostępu do localStorage - ustawienie obowiązuje do odświeżenia strony
    }
};
